<template>
  <fragment>
    <v-container fluid pa-0>
      <v-layout justify-center column fill-height>
        <template v-for="(content, index) in inputArray">
          <v-layout :key="index" row fill-height>
            <v-flex shrink>
              <v-layout column fill-height>
                <v-flex grow :style="(index === inputArray.length - 1) ? 'min-height: 40px;' : ''">
                </v-flex>
                <v-flex shrink>
                  <CButton
                    v-if="(index === inputArray.length - 1) && !(limit > 0 && inputArray.length === limit)"
                    small
                    fab
                    color="accent"
                    @click="() => onAddContent(inputArray)"
                  >
                    <v-icon>add</v-icon>
                  </CButton>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex shrink :style="(index === inputArray.length - 1) ? 'margin-left: -30px' : 'margin-left:10px'">
              <KeywordField
                v-model="input[index]"
                :mode="mode"
                :index="index"
                :name="'keyword_' + index"
                :label="name"
                remarks=""
                :rules="required && index === 0 ? 'required' : ''"
                :width="width"
                :placeholder="placeholder"
                :resourceName="resourceName"
              />
            </v-flex>

            <v-flex shrink>
              <v-layout column fill-height>
                <v-flex grow>
                  <CButton
                          color="red"
                          small
                          fab
                          dark
                          @click="() => onDeleteContent(inputArray, index)"
                  >
                    <v-icon>clear</v-icon>
                  </CButton>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </template>

        <div v-if="duplicated" style="color: red">
          同一のキーワードが入力されています
        </div>
        <div v-if="candidates.length > 0">
          候補の文字を選択すると、アプリでの検索時にキーワードに合致する可能性が高くなります
        </div>
      </v-layout>
    </v-container>

  </fragment>
</template>

<script>
import KeywordField from "./keyword";

export default {
  components: {
    KeywordField
  },
  props: {
    input: {
      type: Array,
      default: () => []
    },
    resourceName: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: "edit",
      validator: value => ["show", "create", "edit"].indexOf(value) !== -1
    },
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "200px"
    },
    limit: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  watch: {
    "input": {
      handler(value) {
        let s = new Set(value);
        this.duplicated = s.size !== value.length;
      }
    }
  },
  data() {
    return {
      duplicated: false
    };
  },
  computed: {
    isShowMode() {
      return this.mode === "show";
    },
    isCreateMode() {
      return this.mode === "create";
    },
    isEditMode() {
      return this.mode === "edit";
    },
    inputArray() {
      if(this.input.length < 1) {
        return [""];
      }
      return this.input;
    },
    candidates() {
      return this.$store.getters[`common/keywords/options/options`];
    }
  },
  methods: {
    onAddContent(input) {
      let initEntity = "";

      if(!(this.limit > 0 && input.length + 1 > this.limit) && input[input.length - 1] !== initEntity)
      {
        input.push(initEntity);
      }
    },
    onDeleteContent(input, index) {
      input.splice(index, 1);
      if(input.length === 0) {
        this.onAddContent(input);
      }
    }
  },
  created(){
  }
};
</script>
<style module lang="scss">
.content-card {
  margin: 5px 0;
}
</style>
